import { FormControlBase } from './form-control-base';

export class DatepickerControl extends FormControlBase<string> {
    public controlType: string = 'datepicker';
    public preventKeys: any = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 109, 189];
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/datepicker-control.ts